import {Suspense, useEffect, useState} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit, useAuth} from './modules/auth'
import {GoogleOAuthProvider} from '@react-oauth/google'
import {InvestorDatabaseProvider} from './modules/investor-database/core/InvestorContext'
import {getLocaleData} from '../_metronic/partials/layout/core/_requests'
import axios from 'axios'
import useAxiosResponse from './modules/widgets/components/General/useAxiosResponse'
import {BillingModal} from './modules/onboarding/views/BillingModal'
import useGetBillingData from './hooks/useGetBillingData'
import {MoveToFolderDataProvider} from './modules/data-rooms/core/FileToFolderAuth'
import {BillingAccessModal} from './modules/profile/views/BillingAccessModal'
import {Toaster} from './modules/widgets/components/General/Toaster'
import {DigitalSigningProvider} from './modules/digital-signing/core/DigitalSigningContext'
import {StakeholdersProvider} from './modules/stakeholders/Stakeholders'
import brandingConfig from '../config/brandingConfig'
import {getUserByToken, refreshTokenApi} from './modules/auth/core/_requests'

const App = () => {
  const {
    showBillingModal,
    setShowBillingModal,
    companyId,
    currentState,
    selected,
    currencyBill,
    showBillingAccessModal,
    setShowBillingAccessModal,
    billingPortalUrl,
    userToken,
    setPlanStatus,
    setInvoiceStatus,
    setCompanyQueuePosition,
    setUseCase,
    setRole,
  } = useAuth()
  const [status, setStatus] = useState(true)
  const {getBillingDetailsAPI, onAccessBillingPortal} = useGetBillingData(companyId!)
  let refreshTokenTime = Number(process.env.REACT_APP_TOKEN_REFRESH_TIME) || 60
  const I18N_CONFIG_KEY = process.env.REACT_APP_I18N_CONFIG_KEY || 'i18nConfig'
  const Locale = async () => {
    try {
      const {
        data: {data, success},
      } = await getLocaleData()
      if (success) {
        data.forEach((e: any) => {
          if (e.key === 'locale') {
            if (e.value === 'fr_FR') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'fr'}))
              }
            } else if (e.value === 'de_GN') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'de'}))
              }
            } else if (e.value === 'ja_JP') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'ja'}))
              }
            } else if (e.value === 'es_ES') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'es'}))
              }
            } else if (e.value === 'zh_CN') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'zh'}))
              }
            } else if (e.value === 'hi_HI') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'hi'}))
              }
            } else if (e.value === 'bn_BN') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'bn'}))
              }
            } else if (e.value === 'it_IT') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'it'}))
              }
            } else if (e.value === 'ko_KO') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'ko'}))
              }
            } else if (e.value === 'pt_PT') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'pt'}))
              }
            } else if (e.value === 'ru_RU') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'ru'}))
              }
            } else {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'en'}))
              }
            }
          } else if (e.key === 'dateFormat') {
            localStorage.setItem('dateFormat', e.value)
          } else if (e.key === 'timeFormat') {
            localStorage.setItem('timeFormat', e.value)
          } else if (e.key === 'timezone') {
            localStorage.setItem('timeZone', e.value)
          }
        })
      }
    } catch (err) {
      console.log(err)
    }
  }
  useAxiosResponse(axios)

  useEffect(() => {
    if (userToken) {
      Locale()
    }
  }, [companyId, userToken]) // eslint-disable-line react-hooks/exhaustive-deps

  // const refreshToken = async () => {
  //   if (!userToken || !companyId) return
  //   try {
  //     const {
  //       data: {success, data},
  //     } = await refreshTokenApi()
  //     if (success) {
  //       setInvoiceStatus(data?.companyPlanStatus?.invoiceStatus)
  //       setPlanStatus(data?.companyPlanStatus?.planStatus)
  //       const {data: userData} = await getUserByToken(data.token)
  //       if (userData?.data) {
  //         const findCompany = userData?.data?.company?.find(
  //           (company: {companyId: number}) => company.companyId === companyId
  //         )
  //         if (findCompany) {
  //           setCompanyQueuePosition(findCompany?.queuePosition)
  //           setUseCase(findCompany?.useCase)
  //           setRole(findCompany?.roles?.roleName?.toLowerCase())
  //         }
  //       }
  //     }
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }

  const refreshToken = async () => {
    if (!userToken || !companyId) return
    try {
      const {
        data: {success, data},
      } = await refreshTokenApi()
      if (success) {
        // await saveAuth(data)
        // setUserToken(data.token)
        if(data?.companyPlanStatus?.invoiceStatus){
          setInvoiceStatus(data.companyPlanStatus.invoiceStatus)
        }
        if(data?.companyPlanStatus?.planStatus){
          setPlanStatus(data.companyPlanStatus.planStatus)
        }
        const {data: userData} = await getUserByToken(data.token)
        if (userData?.data) {
          const findCompany = userData?.data?.company?.find(
            (company: {companyId: number}) => company.companyId === companyId
          )
          if (findCompany) {
            setCompanyQueuePosition(findCompany?.queuePosition)
            setUseCase(findCompany?.useCase)
            setRole(findCompany?.roles?.roleName?.toLowerCase())
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    // Run once on mount
    if (!userToken || !companyId) return
    refreshToken()

    // Run every 5 minutes
    const interval = setInterval(() => {
      refreshToken()
    }, refreshTokenTime * 1000)

    return () => clearInterval(interval)
  }, [userToken, companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // Dynamically update the favicon
    const favicon = document.getElementById('favicon') as HTMLLinkElement
    if (favicon) {
      favicon.href = brandingConfig.favicon
    }
    // Dynamically update the document title
    document.title = brandingConfig.brandName

    //Dynamically update the loader
    const loader = document.getElementById('loader-image') as HTMLImageElement
    if (loader) {
      loader.src = brandingConfig.loader
      loader.style.display = 'block'
    }

    // Dynamically update the meta description
    const metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute('content', brandingConfig.brandDescription)
    }
  }, [])

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Toaster />
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID as string}>
        <I18nProvider>
          <LayoutProvider>
            <AuthInit>
              <InvestorDatabaseProvider>
                <StakeholdersProvider>
                  <DigitalSigningProvider>
                    <MoveToFolderDataProvider>
                      <Outlet />
                      <MasterInit />
                      <BillingModal
                        setModalShow={setShowBillingModal}
                        modalShow={showBillingModal}
                        currencyBill={currencyBill}
                        selected={selected}
                        currentState={currentState}
                        upgrade={true}
                        companyId={companyId}
                        getBillingDetails={getBillingDetailsAPI}
                        onAccessBillingPortal={onAccessBillingPortal}
                      />
                      <BillingAccessModal
                        showBillingAccessModal={showBillingAccessModal}
                        setShowBillingAccessModal={setShowBillingAccessModal}
                        billingPortalUrl={billingPortalUrl}
                      />
                    </MoveToFolderDataProvider>
                  </DigitalSigningProvider>
                </StakeholdersProvider>
              </InvestorDatabaseProvider>
            </AuthInit>
          </LayoutProvider>
        </I18nProvider>
      </GoogleOAuthProvider>
    </Suspense>
  )
}

export {App}
